import React from "react";
import { Link } from "react-router-dom";
import { Alert, Button } from "@mui/material";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import { useTranslation } from "react-i18next";
import { StatusCard } from "./marketing/MarketingParts";

export default function PaymentFailure() {
  const { t } = useTranslation();
  return (
    <StatusCard
      icon={<ErrorOutlineRoundedIcon />}
      tone="error"
      title={t("mkp_fail_title")}
      actions={
        <Button variant="contained" size="large" component={Link} to="/plans">
          {t("mkp_back_plans")}
        </Button>
      }
    >
      <Alert severity="error">{t("mkp_fail_msg")}</Alert>
    </StatusCard>
  );
}
